import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogContent: {
            display: 'flex',
            minWidth: '500px',
            minHeight: '300px',
        },
    })
);
